function FrameContentStyleIsolator() {
  const styleTags = document.querySelectorAll(
    '#ModuleViewer .canvas-content style',
  );
  if (styleTags.length !== 0) {
    const stylePropertyPrefix =
      '#ModuleViewer .module-viewer-style .canvas-content';

    // Helper function to process CSS rules recursively
    const processRule = (rule: CSSRule) => {
      const ruleType = rule.constructor.name;

      if (ruleType.includes('CSSStyleRule')) {
        // Handle regular CSS style rules
        const styleRule = rule as CSSStyleRule;
        const selectorTextSplit = styleRule.selectorText
          .split(',')
          .map((cssText) =>
            cssText.trim().search(stylePropertyPrefix) === -1
              ? `${stylePropertyPrefix} ${cssText.trim()}`
              : cssText.trim(),
          );
        styleRule.selectorText = selectorTextSplit.join(', ');
      } else if (ruleType.includes('CSSMediaRule')) {
        // Handle media queries - process nested rules
        const mediaRule = rule as CSSMediaRule;
        if (mediaRule.cssRules) {
          Array.from(mediaRule.cssRules).forEach(processRule);
        }
      } else if (ruleType.includes('CSSSupportsRule')) {
        // Handle @supports rules - process nested rules
        const supportsRule = rule as CSSSupportsRule;
        if (supportsRule.cssRules) {
          Array.from(supportsRule.cssRules).forEach(processRule);
        }
      } else if (ruleType.includes('CSSContainerRule')) {
        // Handle @container rules - process nested rules
        const containerRule = rule as CSSContainerRule;
        if (containerRule.cssRules) {
          Array.from(containerRule.cssRules).forEach(processRule);
        }
      }
    };

    styleTags.forEach((styleTag) => {
      const customStylesheet = (styleTag as HTMLStyleElement).sheet;

      if (customStylesheet !== null) {
        const rules = customStylesheet.cssRules;
        Array.from(rules).forEach(processRule);
      }
    });
  }
}

export default FrameContentStyleIsolator;
